<template>
  <v-layout align-center justify-center row fill-height>
    <v-dialog v-model="changed" persistent >
      <v-card>
        <v-card-title><h3>パスワードを変更しました</h3></v-card-title>
        <v-card-text>
          確認ボタンをクリックするとログアウトします。
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn @click="logOutAndToLogin">確認</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-flex xs12 md4>
      <v-card>
        <v-card-title>
          <v-flex xs12>
            <h2>パスワードの変更</h2>
          </v-flex>
        </v-card-title>
        <v-card-text>
          <!-- <v-flex md10>
            <v-text-field type="text" label="名前" v-model="user.name" :readonly="true" />
          </v-flex> -->
          <v-flex md10>
            <v-text-field type="text" label="Eメール" v-model="user.email" :readonly="true" />
          </v-flex>
          <v-flex md10>
            <v-text-field type="password" label="現在のパスワード" v-model="password" />
          </v-flex>
          <v-flex md10>
            <v-text-field type="password" label="新パスワード" v-model="newPassword" />
          </v-flex>
          <v-flex md10>
            <v-alert :value="msg.length>0" :type="alertType">{{msg}}</v-alert>
          </v-flex>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn @click="changePassword">再設定</v-btn>

        </v-card-actions>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
import auth from '@/components/fireAuthInit'
import firebase from 'firebase'
import { authErrorCodeToMessage } from '@/utils/errorMessages.js'
import { mapMutations, mapActions, mapState, mapGetters } from 'vuex'
export default {
  data() {    return {
      email: "",
      name: "",
      password: "",
      newPassword: "",
      msg: "",
      alertType: "success",
      changed:false

    }
  },
  mounted() {
    console.log(this.user)
  },
  methods: {
    async changePassword() {
      const user = auth.currentUser
      const cred = firebase.auth.EmailAuthProvider.credential(user.email, this.password);
      this.changeLoadingState(true)
      try {
        // credentialをreauthenticateWithCredentialに渡す
        await user.reauthenticateWithCredential(cred)
        // 再認証に成功した場合のみ、updatePasswordメソッドを実行する
        await user.updatePassword(this.newPassword)
        this.msg = "パスワードを変更しました。"
        this.alertType = "success"
        this.changeLoadingState(false)
        this.changed=true
      } catch (e) {
        console.log(e)
        console.log(authErrorCodeToMessage(e.code))
        this.msg = authErrorCodeToMessage(e.code)
        this.alertType = "error"
        this.changeLoadingState(false)
      }
    },
    logOutAndToLogin() {
      this.logOut()
      this.$router.push({ name: "login", params: { company_id: this.$route.params.company_id } })
    },
    ...mapActions('auth', ["logOut"]),
    ...mapMutations('app', ['changeLoadingState'])
  },
  computed: {
    ...mapGetters('auth', ['user'])
  }
}
</script>
<style lang="css" scoped>
div.logo {
  font-size: 20px;
  color: #ff5722;
  font-family: YuGothicM, Roboto, sans-serif;
  font-weight: bold;
}
</style>

